import { COLORS } from '@btime/constants'
import React from 'react'

import { CUSTOM_TEMPLATE, NO_TEMPLATE } from '../_templates/Constants'
import { HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE } from '../_templates/Templates'
import { Title } from '../../../../components/presentation/Text'
import { usePdfOptionsForm } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import DropdownListItem from '../../../../components/list/DropdownListItem'
import Line from '../../../../packages/kiti/components/helpers/Line'
import LogoSection from './sections/LogoSection'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'
import useHandleChangeTamplate from '../_helpers/handleTemplate'
import Sticky from '../../../../components/helpers/Sticky'
import TitleSection from './sections/TitleSection'
import SubtitleSection from './sections/SubtitleSection'
import TemplateSection from './sections/TemplateSection'
import QrCodeSection from './sections/QrCodeSection'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import ActivationDetails from './sections/ActivationDetails'

const OptionsForm = () => {
  const form = usePdfOptionsForm()
  const handleChangeTamplate = useHandleChangeTamplate()

  return (
    <>
      <Sticky key={form.template}>
        <SeparatorWrapper weight={4} usePadding>
          <Title size="h5" color={COLORS.dark3}>
            Configurações da impressão
          </Title>
        </SeparatorWrapper>

        <DropdownListItem
          label="Modelo"
          value={form.template}
          onChange={handleChangeTamplate}
          options={[
            { label: 'Sem template', value: NO_TEMPLATE },
            {
              label: 'Template Horizontal',
              value: HORIZONTAL_TEMPLATE
            },
            {
              label: 'Template Vertical',
              value: VERTICAL_TEMPLATE
            },
            {
              label: 'Template customizado',
              value: CUSTOM_TEMPLATE
            }
          ]}
        />
        <Line color="light5" />

        <TemplateSection />
        <QrCodeSection />
        <LogoSection />
        <TitleSection />
        <SubtitleSection />
        <ActivationDetails />
        <Separator size={10} usePadding={true} />
      </Sticky>
    </>
  )
}

export default OptionsForm
